const scheduleAutoRefresh = (cb, timeInSeconds) => {
    // setTimeout(() => {
    //     console.log("Refreshing!"); // Debug only
        cb();
    //     scheduleAutoRefresh(cb, timeInSeconds); // Set to run again
    // }, timeInSeconds * 1000);
}

module.exports = { scheduleAutoRefresh };
